/*
 * Copyright (c) 2022 CalAmp Corp. All Rights Reserved
 */
import {useEffect, useState} from 'react';
import {get} from '@ion/core/src/environment/environment';
import {hasRole} from '@ion/core/src/security/helpers';
import {safeJSONParse} from '@ion/core/src/utils/JSONUtils';
import {useAuthenticatedUser} from '../users/useAuthenticatedUser';

/**
 * Determines if the currently authenticated user can access the message endpoint's feature
 * when working with Account entities (add/update).
 *
 * Currently, a user must have a role of FW Uploader, Calamp Support, or Customer Admin.
 */
export const useMessageEndpointAccess = (): boolean => {
  const {roles} = useAuthenticatedUser();
  const [userHasAccess, setUserHasAccess] = useState<boolean>(false);
  useEffect(() => {
    const messageEndpointsRoles = get('messageEndpointsRoles');
    setUserHasAccess(hasRole(roles, safeJSONParse(messageEndpointsRoles)));
  }, []);
  return userHasAccess;
};

export default useMessageEndpointAccess;
